import { render } from "./ProfileEditConfirm.vue?vue&type=template&id=1b37f07a&scoped=true"
import script from "./ProfileEditConfirm.vue?vue&type=script&lang=js"
export * from "./ProfileEditConfirm.vue?vue&type=script&lang=js"

import "./ProfileEditConfirm.vue?vue&type=style&index=0&id=1b37f07a&lang=scss&scoped=true"

import exportComponent from "/var/www/html/app_player/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1b37f07a"]])

export default __exports__